module.exports = __webpack_public_path__ + "static/Candia_The Chocolate Penguin-edfd574bdc6a67ec05a3cef207a22fd9.png";